import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios, { AxiosResponse } from 'axios';

import { SurveyValueExcelFailure } from '../../types/entity.types';
import { SagaPayload } from '../api.types';
import { UploadSurveyRequest, UploadSurveyResponse } from './survey.types';

import { UPLOADING_SURVEY } from './survey.constants';

import { requestUploadSurvey } from './survey.actions';

import { getUploadSurveyRequest } from './survey.endpoints';

import { addSpinner, addSystemNotice, removeSpinner } from '../../slices/system/system.slice';

import { getErrorMessage } from '../../utils/api.util';
import { ERROR, SUCCESS } from '../../utils/constants';

export function* performSurveyUpload({
  payload
}: SagaPayload<UploadSurveyRequest, undefined, SurveyValueExcelFailure[]>) {
  const { requestData, onError } = payload;

  try {
    yield put(addSpinner(UPLOADING_SURVEY));

    const [endpoint, options] = getUploadSurveyRequest(requestData);

    const { data }: AxiosResponse<UploadSurveyResponse> = yield call(axios, endpoint, options);

    const status = data.status;
    const results = data.results;
    if (status === 'FAILED' && results && onError) {
      yield call(onError, results);
    }

    yield put(addSystemNotice({ type: status === 'FAILED' ? ERROR : SUCCESS, message: data.message }));
  } catch (error) {
    const results: SurveyValueExcelFailure[] | undefined = (
      error as { response?: { data?: { results?: SurveyValueExcelFailure[] } } }
    ).response?.data?.results;

    if (results && onError) {
      yield call(onError, results);
    } else {
      const message = getErrorMessage(error);
      yield put(addSystemNotice({ type: ERROR, message }));
    }
  } finally {
    yield put(removeSpinner(UPLOADING_SURVEY));
  }
}

export function* watchForSurveyUploadRequest() {
  yield takeLatest(requestUploadSurvey.type, performSurveyUpload);
}

export default function* surveySaga() {
  yield all([watchForSurveyUploadRequest()]);
}
